<template>
  <div class="tabs overflow-x-auto">
    <div role="list" class="tablist">
      <template v-for="(tab, i) in tabs" :key="i">
        <tab :link="tab.link">
          {{ $t(tab.label) }}
        </tab>
      </template>
      <slot />
    </div>
    <div class="ml-auto flex gap-x-5">
      <slot name="actions" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Tab from './Tab.vue';

const route = useRoute();
const tabs = computed(() => [
  ...((route.meta.tabs ?? []) as Array<{ label: string; link: string }>),
]);
</script>

<style lang="scss" scoped>
.tabs {
  @apply sticky top-0 flex justify-between items-center;
  @apply pb-12 pt-10 px-12;
  @apply border-b-2 border-b-background-light;
  background: rgba(var(--color-background-light-100-rgb), 0.8);
  z-index: 100;
  grid-area: tabs;
}

.tablist {
  @apply flex sticky top-0;
  @apply gap-x-10;
}
</style>
